import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Input } from '~/components/ui/input'
import { MAX_CHAPTER_TITLE } from '~/pages/backoffice/admin/sessions/path-chapters'

type IProps = {
  number: number
  title: string
  onRename: (title: string) => void
  onRemove: () => void
}

/**
 * Titre d'un chapitre dans l'éditeur de parcours (#75). Le retirer ne retire
 * aucun module : ses étapes rejoignent le chapitre précédent.
 */
function ChapterHeader({ number, title, onRename, onRemove }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2 border-b border-border pb-1.5">
      <span className="shrink-0 text-xs font-semibold text-muted-foreground">
        {t('sessions.path.chapter.label', { number })}
      </span>
      <Input
        className="h-8 flex-1 font-medium"
        maxLength={MAX_CHAPTER_TITLE}
        value={title}
        onChange={e => onRename(e.target.value)}
        aria-label={t('sessions.path.chapter.title', { number })}
      />
      <Button
        type="button"
        variant="ghost"
        className="size-8 shrink-0 p-0"
        onClick={onRemove}
        aria-label={t('sessions.path.chapter.remove', { number })}
      >
        <X className="size-4" />
      </Button>
    </div>
  )
}

export default ChapterHeader
